<section>
    <h1 class="header">{{ pageData.pageTitle }}</h1>
    <div class="progress-block">
        <h3 class="progress-header" id="pending-head">{{ pageData.header }}</h3>
        <div class="shadow-circle">
            <xm-media-image class="logo" [imageOptions]="logoIcon" size="height"></xm-media-image>
        </div>
        <p class="description">{{ pageData.subhead }}</p>
        <div class="actions">
            <div class="disclaimer" *ngIf="pageData.disclaimer">
                <xm-media-image aria-hidden="true" class="email-icon" size="height" [imageOptions]="emailIcon"></xm-media-image>
                <cms-text class="disc-text" [originalText]="pageData.disclaimer"></cms-text>
            </div>
        </div>
        <button class="xm-btn-primary-light btn" (click)="endLevelMoveFlow()">{{ pageData.cta }}</button>
    </div>
</section>
